const WIDGET_PREFIX = '/widget';
const BOOK_APPOINTMENT_PREFIX = '/book-appointment';
const ROADBOOK_PREFIX = '/roadbook';
const LANDING_VISIT_PREFIX = '/vyzov-veterinara-na-dom';
const PERSONAL_PREFIXES = ['/profile', '/profile-doctor', '/profile-clinic'] as const;

function matchesPathPrefix(path: string, prefix: string): boolean {
  const base = prefix.endsWith('/') ? prefix.slice(0, -1) : prefix;

  return path === base || path === `${base}/` || path.startsWith(`${base}/`);
}

/**
 * Показывать cookie-баннер только на публичных страницах.
 * Скрыт на widget, бронировании, roadbook, лендинге выезда на дом (свой
 * липкий чек-аут занимает низ экрана на мобильном) и в личном кабинете.
 */
export function shouldShowCookieConsentBanner(path: string, layout?: string): boolean {
  if (layout === 'personal') {
    return false;
  }

  if (matchesPathPrefix(path, WIDGET_PREFIX)) {
    return false;
  }

  if (matchesPathPrefix(path, BOOK_APPOINTMENT_PREFIX)) {
    return false;
  }

  if (matchesPathPrefix(path, ROADBOOK_PREFIX)) {
    return false;
  }

  if (matchesPathPrefix(path, LANDING_VISIT_PREFIX)) {
    return false;
  }

  for (const prefix of PERSONAL_PREFIXES) {
    if (matchesPathPrefix(path, prefix)) {
      return false;
    }
  }

  return true;
}
